import React from "react";
import Page from "../../../../components/page/Page";
import PageContent from "../../../../components/page/PageContent";
import PageHeader from "../../../../components/page/PageHeader";
import PageTitle from "../../../../components/page/PageTitle";
import {_transl} from "../../../../store/localization/TranslMessasge";
import UsersGrid from "./UsersGrid";
import {UsersTranslationKey} from "./UsersTranslationKey";

export interface UserPageProps {
}

export default function UsersPage(props: Readonly<UserPageProps>) {

    return (
        <Page>
            <PageHeader>
                <PageTitle title={_transl(UsersTranslationKey.USERS)} />
            </PageHeader>
            <PageContent>
                <UsersGrid/>
            </PageContent>
        </Page>
    );
}
